function shadow(target, source, properties) {
    properties = properties || Object.keys(source)
    properties.forEach(key => {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: true,
            get() {
                return source[key]
            },
            set(value) {
                source[key] = value
            },
        })
    })
}

class NonReactiveChartDataset {
    constructor(dataset) {
        Object.defineProperty(this, '_dataset', { value: dataset })
        // This is the whole reason we're in this mess; chart.js wants to write to
        // the _meta property which causes a loop in reactivity in Vue if we try
        // to deep watch the chart data object. We want to deep watch the chart data
        // object so we can call update() at all the right times
        Object.defineProperty(this, '_meta', { value: {}, writable: true })
        this.update()
    }

    update() {
        shadow(this, this._dataset)
    }
}

class NonReactiveChartData {
    constructor() {
        this.__data = { datasets: [] }
        this.__nonReactiveDatasets = []
    }

    update(data) {
        this.__data = data

        // directly shadow everything except the datasets, since the only (known) metadata
        // is buried in the datasets collection
        shadow(
            this,
            this.__data,
            Object.keys(data).filter(key => key !== 'datasets')
        )

        const nonReactiveDatasets = this.__data.datasets.map(
            original =>
                // try to preserve the original instance and its metadata; chart.js uses different
                // animations when appending a new dataset vs creating entirely new datasets
                this.__nonReactiveDatasets.find(nonReactive => nonReactive._dataset === original) ||
                new NonReactiveChartDataset(original)
        )

        this.__nonReactiveDatasets = nonReactiveDatasets
    }

    get datasets() {
        return this.__nonReactiveDatasets
    }

    set datasets(value) {
        // Chart.js does this:
        //     chart.datasets = chart.datasets || []
        // instead of:
        //     chart.datasets || (chart.datasets = [])
        // In our case it will always just be setting back the value from the getter,
        // so we just ignore any attempts to set it.
    }
}

export default NonReactiveChartData
